module.exports = __webpack_public_path__ + "images/349125eed96e98a70eca9a7a689a2848.jpg";